// @flow
import { handleResponseOld, makeDelete, makeGet } from './helpers';

type GetCertCaptureTypeParams = {
    authToken: string,
    bidderId: number,
    deployment: string,
};

type GetCertificatesTypeParams = {
    authToken: string,
    bidderId: number,
    deployment: string,
};

type GetCertificateDownloadTypeParams = {
    authToken: string,
    bidderId: number,
    certificateId: number,
    deployment: string,
};

type DeleteCertificateTypeParams = {
    authToken: string,
    bidderId: number,
    certificateId: number,
    deployment: string,
};

export default {
    deleteCertificate: ({ authToken, bidderId, certificateId, deployment }: DeleteCertificateTypeParams) =>
        new Promise<any>((resolve, reject) => {
            const request = makeDelete({
                apiPath: `exemption/bidder/${bidderId}/certificates/${certificateId}`,
                authToken,
                deployment,
                path: '<TAXES-API>',
            });
            request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
        }),
    getCertCaptureToken: ({ authToken, bidderId, deployment }: GetCertCaptureTypeParams) =>
        new Promise<any>((resolve, reject) => {
            const request = makeGet({
                apiPath: `exemption/bidder/${bidderId}/token`,
                authToken,
                deployment,
                path: '<TAXES-API>',
            });
            request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
        }),
    getCertificateDownload: ({ authToken, bidderId, certificateId, deployment }: GetCertificateDownloadTypeParams) =>
        new Promise<any>((resolve, reject) => {
            const request = makeGet({
                apiPath: `exemption/bidder/${bidderId}/certificates/${certificateId}/pdf`,
                authToken,
                deployment,
                path: '<TAXES-API>',
            });
            request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
        }),
    getCertificates: ({ authToken, bidderId, deployment }: GetCertificatesTypeParams) =>
        new Promise<any>((resolve, reject) => {
            const request = makeGet({
                apiPath: `exemption/bidder/${bidderId}/certificates`,
                authToken,
                deployment,
                path: '<TAXES-API>',
            });
            request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
        }),
};
